import React from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../components/BackButton";
import Breadcrumbs from "../components/Breadcrumbs";
import Button from "../components/Button";
import SellerMarketProductsBlock from "../components/SellerMarketProductsBlock";
import ManagerFooter from "../components/ManagerFooter";
import "./scss/seller-products-page.scss";

export default function SellerProductsPage() {
  const navigate = useNavigate();

  return (
    <>
      <div className="seller-products-page">

        {/* HEADER */}
        <BackButton />

        <Breadcrumbs
          items={[
            { label: "Главная", path: "/seller/dashboard" },
            { label: "Товары" }
          ]}
        />

        <h2>Товары</h2>

        {/* ADD BUTTON */}
        <Button
          className="btn-primary large seller-products-page__add-btn"
          onClick={() => navigate("/seller/product/create")}
        >
          + Добавить товар
        </Button>

        {/* PRODUCTS BLOCK */}
        <SellerMarketProductsBlock />

      </div>

      <ManagerFooter />
    </>
  );
}
